<template>
    <section style="min-width: 370px;" :class="[ marginTopClass, marginBottomClass ]">
      <div class="container-fluid p-0 social-media-container">
        <div class="container pb-0 px-3 px-lg-0 px-xl-0 d-flex flex-row" :class="layoutClass">
          <div v-if="isSocialMediaSiblingsVisible" class="w-100 row m-0 py-3 d-flex flex-row justify-content-between align-items-center">
            <slot></slot>
            <div :class="socialShareColumnClass" class="col-lg-3 col-xl-3 p-0 mt-2 mt-lg-0 mt-xl-0">
              <SocialShareBookmark
                :class="socialShareFlexJustifyClass"
                class="m-0 p-0"
                id="social-share"
                :title="title"
                :description="description"
                :type="type"
              />
            </div>
          </div>
          <div v-else class="py-3">
            <SocialShareBookmark
              class="justify-content-center justify-content-md-start"
              id="social-share"
              :title="title"
              :description="description"
              :type="type"
            />
          </div>
        </div>
      </div>
    </section>
</template>

<script>
    import SocialShareBookmark from '../../social-share-bookmark.vue';
    export default {
        props: {
            title: String,
            description: String,
            type: String,
            isSocialMediaSiblingsVisible: {
              type: Boolean,
              default: false,
            },
            hasTopMargin: {
              type: Boolean,
              default: false
            },
            hasBottomMargin: {
              type: Boolean,
              default: false
            },
            socialShareColumnClass: {
              type: String,
              default: 'col-6',
            },
            socialShareFlexJustifyClass: {
              type: String,
              default: 'justify-content-end'
            }
        },
        components: {
            SocialShareBookmark,
        },
        computed: {
          layoutClass() {
            return this.isSocialMediaSiblingsVisible ? 'justify-content-between' : 'justify-content-center';
          },
          marginTopClass() {
            return this.hasTopMargin ? 'mt-5' : 'mt-0';
          },
          marginBottomClass() {
            return this.hasBottomMargin ? 'mb-5' : 'mb-0';
          }
        },
    }
</script>

<style scoped>
    .social-media-container {
        border-top: 1px solid #000000;
        border-bottom: 1px solid #000000;
    }
</style>